// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"9c7ecf9e","197":"99235cb8","207":"bfec6638","404":"e6dc6818","535":"6afd337f","652":"8a6d358d","694":"fb87e078","725":"83283740","837":"0d65193e"}[chunkId] + ".chunk.js";
};